const Features2 = ({ data, id }) => {
    return (
        <section id="products" className='py-4 mt-6 md:mt-16 mb-16'>
            <div className="w-full px-4 lg:px-0">
                <div className="w-full lg:w-[70%] lg:max-w-[1440px] mx-auto text-gray-600">
                    <div className='relative max-w-xl mx-auto sm:text-center'>
                        <h3 className='text-gray-800 text-3xl font-semibold sm:text-4xl'>
                            {data.title}
                        </h3>
                        <div className='mt-3 max-w-xl'>
                            <p>{data.subtitle}</p>
                        </div>
                    </div>

                    <div className="grid gap-4 sm:gap-6 lg:gap-8 sm:grid-cols-1 lg:grid-cols-2">
                        {data.items.map((item, idx) => (
                            <a
                                key={idx}
                                href={item.buttonLink}
                                target={item.target ? item.target : '_self'}
                                className="shadow-xl relative flex flex-col border-blue-100 py-8 px-4 sm:py-12 sm:px-8 rounded-xl border-2 hover:shadow-[0_0_15px_5px_rgba(59,130,246,0.3)] transition duration-200 cursor-pointer text-gray-800 h-full"
                            >
                                {/* 标题 + 图标：固定高度 */}
                                <div className="flex justify-between items-center min-h-[64px] mb-4">
                                    <span className="text-lg sm:text-2xl font-semibold">{item.name}</span>
                                    {item.img && (
                                        <img
                                            src={item.img}
                                            alt="icon"
                                            className="w-24 h-24 object-contain max-sm:w-10 max-sm:h-10"
                                        />
                                    )}
                                </div>
                                {/* 描述文字区域 */}
                                <div className="text-sm sm:text-lg leading-relaxed sm:leading-loose">
                                    {item.desc}
                                </div>
                            </a>

                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Features2;
